import React, { useState, useContext } from "react";

import "./Dashboard.scss"; // Import the CSS file

//import context
import { MyContext } from "../../../../tenantsDashContext";

//icons
import { RxDashboard } from "react-icons/rx";
import { MdPayment } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { RiMessage2Line } from "react-icons/ri";
import { SlLogout } from "react-icons/sl";
import { IoPersonOutline } from "react-icons/io5";

//assets
import Logo from "../../../../resources/logo.png";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { handleLogout } from "../../../../redux/slices/sliceActions";


const Navigation = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const [activeItem, setActiveItem] = useState("Overview"); // State to keep track of the active item
  const dispatch = useDispatch();
  
  const handleNavItemClick = (item) => {
  if (item === "Logout") {
       dispatch(handleLogout());
       localStorage.removeItem("user");
       window.location.href = "/signin";
     }
    setActiveItem(item); // Update the active item state when a nav item is clicked
    setSharedValue(item);
    console.log("Shared Value:", sharedValue);
  };

  return (
    <nav className="dashboard-nav">
      <div className="top-nav-section">
        <div>
          <div className="dashboard-header">
            <img src={Logo} alt="website logo" height={"55px"} />
            <div className="company-name">Rentlybuzz</div>
          </div>
          <ul className="dashboard-list">
            <li
              className={`dashboard-item ${
                activeItem === "Overview" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Overview")}
            >
              <div className="text-and-icon">
                <RxDashboard className="dashboard-icon" />
                <div className="text">Overview</div>
              </div>
              <div className="box"></div>
            </li>
            <li
              className={`dashboard-item ${
                activeItem === "Tenants" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Tenants")}
            >
              <div className="text-and-icon">
                <FaUsers className="dashboard-icon" />
                <div className="text">Tenants</div>
              </div>
              <div className="box"></div>
            </li>
            <li
              className={`dashboard-item ${
                activeItem === "Payments" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Payments")}
            >
              <div className="text-and-icon">
                <MdPayment className="dashboard-icon" />
                <div className="text">Payments</div>
              </div>
              <div className="box"></div>
            </li>

            <li
              className={`dashboard-item ${
                activeItem === "Messages" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Messages")}
            >
              <div className="text-and-icon">
                <RiMessage2Line className="dashboard-icon" />
                <div className="text">Messages</div>
              </div>
              <div className="box"></div>
            </li>
          </ul>
        </div>
        <div>
          <ul className={"dashboard-list profile-nav-container"}>
            <li
              className={`dashboard-item ${
                activeItem === "Profile" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Profile")}
            >
              <div className="text-and-icon">
                <IoPersonOutline className="dashboard-icon" />
                <div className="text">Profile</div>
              </div>
              <div className="box"></div>
            </li>
            <li
              className={`dashboard-item ${
                activeItem === "Logout" ? "active" : ""
              }`}
              onClick={() => handleNavItemClick("Logout")}
            >
              <div className="text-and-icon">
                <SlLogout className={`dashboard-icon logout`} />
                <div className="text">Logout</div>
              </div>
              <div className="box"></div>
            </li>
          </ul>
        </div>
      </div>
      <div className="dashboard-list">
        <li className={`dashboard-item email`}>help@rentlybuzz.com</li>
      </div>
    </nav>
  );
};

export default Navigation;
